import {Http} from '../../../Data/config/Http';
import {VisitDTO} from '../models/visit.dto';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

export const VisitAPIDataSourceStore = {
  // Store-specific Operations
  getStoreVisitHistory: async (storeId: string | number): Promise<VisitDTO[]> => {
    try {
      const response = await Http.get<BaseResponse<VisitDTO[]>>(
        API_ROUTES.VISITS.STORE_HISTORY(storeId.toString())
      );
      const items = unwrapResponse(response.data, 'حدث خطأ في جلب تاريخ زيارات المتجر');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  getStoreApprovedVisits: async (storeId: string | number): Promise<VisitDTO[]> => {
    try {
      const response = await Http.get<BaseResponse<VisitDTO[]>>(
        API_ROUTES.VISITS.STORE_HISTORY(storeId.toString())
      );
      const items = unwrapResponse(response.data, 'حدث خطأ في جلب زيارات المتجر المعتمدة');
      const allVisits = Array.isArray(items) ? items : [];
      return allVisits.filter(visit => visit.status === 'approved');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // Bulk Operations
  deleteAllActiveVisits: async (): Promise<{success: boolean, message: string, deletedCount: number}> => {
    try {
      const response = await Http.delete<BaseResponse<{success: boolean, message: string, deletedCount: number}>>(
        API_ROUTES.VISITS.DELETE_ALL_ACTIVE
      );
      return unwrapResponse(response.data, 'حدث خطأ في حذف جميع الزيارات النشطة');
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};
